import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setReferralCode as setQuoteWizardReferralCode } from '../../store/QuoteWizardState';
import { setReferralCode as setPolicystreamReferralCode } from '../../store/policystreamStore';
import { redirectTo, RouteComponentProps } from '@reach/router';
import { useIsPolicyStreamOrganization } from '../PolicyStream/hooks/useIsPolicyStreamOrganization';

// Types
//-----------------------------------------------------------------
interface ReferralsLinkProps extends RouteComponentProps {
  businessId?: number;
  referralCode?: string;
}

//-----------------------------------------------------------------

export const ReferralsLink = (props: ReferralsLinkProps) => {
  // get the referralCode and businessId params props
  const { referralCode, businessId } = props;
  const dispatch = useDispatch();
  const onPolicySteamOrganization = useIsPolicyStreamOrganization(true);

  const [okToNavigate, setOkToNavigate] = useState<boolean>(false);

  // dispatch referral code to redux state
  useEffect(() => {
    if (referralCode) {
      if (onPolicySteamOrganization) {
        dispatch(setPolicystreamReferralCode({ referralCode: referralCode }));
      } else {
        dispatch(setQuoteWizardReferralCode({ referralCode: referralCode }));
      }
      setOkToNavigate(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [referralCode, onPolicySteamOrganization]);

  // navigate to appropriate url if business id exists
  if (okToNavigate) {
    // navigate to business link if businessid is passed

    if (businessId) {
      redirectTo(`/insurtech/businessLink/${businessId}`);
    }
    // otherwise navigate to business selection page
    else if (onPolicySteamOrganization) {
      redirectTo(`/insurance`);
    } else {
      redirectTo(`/insurtech/quote`);
    }
  }
  return null;
};
